import React from 'react';
import Box from 'components/atoms/Box/Box';
import ReactApexChart from 'react-apexcharts';
import PropTypes from 'prop-types';

/**
 * Apex pie chart based on https://apexcharts.com/react-chart-demos/pie-charts/simple-pie-chart/#
 * @param {} props
 */
export default function RadialBarChart(props) {
  const { children, size, ...rest } = props;

  const options = {
    labels: props.labels,
    ...props.options,
  };

  return (
    <Box maxWidth={size ? size : '250px'}>
      <Box width="100%">
        <ReactApexChart options={options} type="radialBar" {...rest}>
          {children}
        </ReactApexChart>
      </Box>
    </Box>
  );
}

RadialBarChart.propTypes = {
  series: PropTypes.arrayOf(PropTypes.number),
  labels: PropTypes.arrayOf(PropTypes.string),
  size: PropTypes.number,
};

RadialBarChart.defaultProps = {};
